import { api } from "@/lib/api";
import type { AuthResult, User } from "@/types/auth";
import type { PlanTier } from "@/types/plan";

export interface LoginPayload {
  email: string;
  password: string;
}

export interface RegisterPayload {
  shopName: string;
  shopPhone?: string;
  shopAddress?: string;
  shopTaxNumber?: string;
  ownerEmail: string;
  ownerPassword: string;
  ownerFirstName: string;
  ownerLastName: string;
  planTier?: PlanTier;
}

export async function loginRequest(payload: LoginPayload): Promise<AuthResult> {
  const { data } = await api.post<AuthResult>("/api/auth/login", payload);
  return data;
}

export async function registerRequest(
  payload: RegisterPayload
): Promise<void> {
  await api.post("/api/auth/register", payload);
}

export async function forgotPasswordRequest(email: string): Promise<void> {
  await api.post("/api/auth/forgot-password", { email });
}

export interface ResetPasswordPayload {
  email: string;
  code: string;
  newPassword: string;
}

export async function resetPasswordRequest(
  payload: ResetPasswordPayload
): Promise<void> {
  await api.post("/api/auth/reset-password", payload);
}

export async function changeOwnPasswordRequest(
  newPassword: string,
  currentPassword?: string
): Promise<User> {
  const { data } = await api.post<User>("/api/auth/change-password", {
    newPassword,
    currentPassword,
  });
  return data;
}
